/* @flow */

export default class CompanyLegalForm {
  id: number;
  name: string;
}
